<template>
  <div class="app-card" :class="{'height-static': !fillHeight}" :style="{minHeight: height, maxHeight: maxHeight}">
    <!--<vue-custom-scrollbar class="scroll-area" :style="{height: height}">-->
      <slot></slot>
    <!--</vue-custom-scrollbar>-->
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
export default {
  name: 'app-card',
  components: {
    vueCustomScrollbar
  },
  props: {
    height: {
      type: String,
      default: ''
    },
    maxHeight: {
      type: String,
      default: ''
    },
    fillHeight: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/app-card.vue